"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workflow_designer_point_model_1 = require("./workflow-designer-point.model");
var workflow_designer_types_1 = require("./workflow-designer.types");
var workflow_designer_create_state_points_model_1 = require("./workflow-designer-create-state-points.model");
var WorkflowDesignerStateModel = /** @class */ (function () {
    function WorkflowDesignerStateModel(id, name, description) {
        if (id === void 0) { id = null; }
        if (name === void 0) { name = null; }
        if (description === void 0) { description = null; }
        var _this = this;
        this.id = id;
        this.name = name;
        this.description = description;
        this.start = false;
        this.type = workflow_designer_types_1.WorkflowDesignerType.STATE;
        this.edit = false;
        this.hover = false;
        this._x = 0;
        this._y = 0;
        this._moveX = 0;
        this._moveY = 0;
        this.width = 200;
        this.height = 42;
        this.resizer = new workflow_designer_point_model_1.WorkflowDesignerPointModel();
        this.createState = new workflow_designer_create_state_points_model_1.WorkflowDesignerCreateStatePointsModel(this);
        this.hasNearest = false;
        this.isFinal = false;
        this.resizer.onDragStart = function (resizer) {
            resizer.position(_this.width, _this.height);
        };
        this.resizer.onMove = function (resizer) {
            _this.position(_this.x, _this.y, resizer.x > 100 ? resizer.x : 100, resizer.y > 40 ? resizer.y : 40);
        };
    }
    Object.defineProperty(WorkflowDesignerStateModel.prototype, "x", {
        get: function () {
            return this._x;
        },
        set: function (x) {
            this._x = x;
            this._moveX = x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerStateModel.prototype, "y", {
        get: function () {
            return this._y;
        },
        set: function (y) {
            this._y = y;
            this._moveY = y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerStateModel.prototype, "centerX", {
        get: function () {
            return this.x + this.width / 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerStateModel.prototype, "centerY", {
        get: function () {
            return this.y + this.height / 2;
        },
        enumerable: true,
        configurable: true
    });
    WorkflowDesignerStateModel.prototype.position = function (x, y, width, height) {
        if (width === void 0) { width = null; }
        if (height === void 0) { height = null; }
        this.x = x;
        this.y = y;
        this.width = width || this.width;
        this.height = height || this.height;
        return this;
    };
    WorkflowDesignerStateModel.prototype.setIsFinal = function (isFinal) {
        this.isFinal = isFinal;
        return this;
    };
    WorkflowDesignerStateModel.prototype.setStart = function () {
        this.type = workflow_designer_types_1.WorkflowDesignerType.START;
        this.start = true;
        return this;
    };
    WorkflowDesignerStateModel.prototype.setEdit = function () {
        this.edit = true;
        return this;
    };
    WorkflowDesignerStateModel.prototype.move = function (x, y, snap) {
        if (snap === void 0) { snap = 10; }
        snap = snap > 1 ? snap : 1;
        this._moveX += x;
        this._moveY += y;
        this._x = Math.round(this._moveX / snap) * snap;
        this._y = Math.round(this._moveY / snap) * snap;
    };
    Object.defineProperty(WorkflowDesignerStateModel.prototype, "transform", {
        get: function () {
            return "translate(" + this.x + " " + this.y + ")";
        },
        enumerable: true,
        configurable: true
    });
    WorkflowDesignerStateModel.prototype.onEdit = function () {
        return this;
    };
    return WorkflowDesignerStateModel;
}());
exports.WorkflowDesignerStateModel = WorkflowDesignerStateModel;
//# sourceMappingURL=workflow-designer-state.model.js.map